export const ChatIcon = ({
  width = 26,
  height = 26,
  className,
  title = "Chat",
  ...rest
}: IconProps) => {
  return (
    <svg
      data-testid="chat-icon"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6943 8.7776C24.7964 8.7776 26.5 10.4811 26.5 12.5833V19.0715C26.4999 21.1737 24.7964 22.8772 22.6943 22.8772H14.8486L9.54785 25.8264C9.39311 25.9122 9.2043 25.9093 9.05176 25.8196C8.89918 25.7298 8.8057 25.566 8.80566 25.3889V22.843C6.93999 22.5983 5.50007 21.0042 5.5 19.0715V12.5833C5.50002 10.4811 7.20362 8.77762 9.30566 8.7776H22.6943ZM9.30566 9.7776C7.75602 9.77762 6.50002 11.0333 6.5 12.5833V19.0715C6.50007 20.6215 7.75605 21.8772 9.30566 21.8772C9.58163 21.8774 9.80566 22.1012 9.80566 22.3772V24.5383L14.4766 21.9407L14.5342 21.9133C14.593 21.8898 14.6559 21.8773 14.7197 21.8772H22.6943C24.244 21.8772 25.4999 20.6215 25.5 19.0715V12.5833C25.5 11.0333 24.244 9.7776 22.6943 9.7776H9.30566ZM11.2939 14.5725C11.9437 14.5725 12.4707 15.0995 12.4707 15.7493C12.4705 16.3989 11.9435 16.9251 11.2939 16.9251C10.6445 16.9249 10.1184 16.3988 10.1182 15.7493C10.1182 15.0996 10.6444 14.5727 11.2939 14.5725ZM16 14.5725C16.6496 14.5727 17.1758 15.0996 17.1758 15.7493C17.1755 16.3988 16.6494 16.9249 16 16.9251C15.3504 16.9251 14.8235 16.3989 14.8232 15.7493C14.8232 15.0995 15.3503 14.5725 16 14.5725ZM20.7061 14.5725C21.3557 14.5726 21.8828 15.0995 21.8828 15.7493C21.8826 16.3988 21.3556 16.925 20.7061 16.9251C20.0565 16.9251 19.5295 16.3989 19.5293 15.7493C19.5293 15.0995 20.0563 14.5725 20.7061 14.5725Z"
        fill="currentColor"
      />
    </svg>
  );
};
